"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _react = require("react");

var ContactType = _react.PropTypes.instanceOf(_ContactRecord.default);

var _default = ContactType;
exports.default = _default;
module.exports = exports.default;